/** Pure decision function for the admin route guard — no React, no browser globals. */

export function adminGuardDecision(
  access: { is_admin: boolean } | null,
  loading: boolean,
): 'loading' | 'allow' | 'deny' {
  if (loading) return 'loading'
  if (access?.is_admin === true) return 'allow'
  return 'deny'
}
